// Placeholder legal copy for West African Tours Ltd.
//
// This is generic boilerplate written to fill the gap flagged in the site
// audit (missing Terms of Sale / Privacy Policy / Cookie Policy / Legal
// Notice). It is NOT a substitute for review by a lawyer familiar with
// Gambian and EU/UK consumer law (the site serves international travellers).
// Update the bracketed placeholders and have counsel review before this is
// treated as the site's real legal footing.

const COMPANY_NAME = "West African Tours Ltd";
const COMPANY_ADDRESS = "P.M.B. 222 Serrekunda, The Gambia, West Africa";
const COMPANY_EMAIL = "Watours@outlook.com";
const COMPANY_PHONE = "(+220) 449 5532";

export const legalPages = {
  terms: {
    title: "General Terms and Conditions of Sale",
    sections: [
      {
        heading: "1. Scope",
        body: `These General Terms and Conditions of Sale ("Terms") govern every request for a quote, booking, tour, excursion, transfer or business/conference service made through the ${COMPANY_NAME} website or directly with our team. By submitting a request through the site, you accept these Terms.`,
      },
      {
        heading: "2. How bookings work",
        body: `${COMPANY_NAME} tours and excursions are tailor-made. Submitting a request through the site is not an immediate purchase: it sends our team the details of what you're looking for. We will contact you, normally within 24 hours, with a personalized quote and next steps. A booking is only confirmed once you have accepted a quote and paid the required deposit or balance.`,
      },
      {
        heading: "3. Prices and payment",
        body: "Prices are provided in the personalized quote and depend on the destination, group size, season and services requested. No price is charged automatically when you submit a request through the site.",
      },
      {
        heading: "4. Cancellations and changes",
        body: "You may ask to modify or cancel a pending request at any time before a quote is confirmed, free of charge, by contacting our team. Once a booking is confirmed and a deposit paid, cancellation terms will be set out in your specific quote.",
      },
      {
        heading: "5. Liability",
        body: `${COMPANY_NAME} acts as an organiser and intermediary for third-party services (accommodation, transport, activities). Our liability is limited to the services we directly provide and as required by applicable law.`,
      },
      {
        heading: "6. Contact",
        body: `Questions about these Terms can be sent to ${COMPANY_EMAIL} or ${COMPANY_PHONE}.`,
      },
    ],
  },
  privacy: {
    title: "Privacy Policy",
    sections: [
      {
        heading: "1. What we collect",
        body: "When you create an account, submit a booking request, contact us, or subscribe to our newsletter, we collect the information you provide: name, email address, phone number, country of residence and the details of your request.",
      },
      {
        heading: "2. How we use it",
        body: "We use your information to respond to your requests, prepare quotes, manage bookings, and, if you opt in, send you travel offers by email. We do not sell your personal data to third parties.",
      },
      {
        heading: "3. Sharing",
        body: "We may share necessary booking details with the specific accommodation, transport or activity providers involved in fulfilling your request.",
      },
      {
        heading: "4. Storage and security",
        body: "Your data is stored on our booking systems and protected with reasonable technical and organisational measures. We retain booking data for as long as needed for legal, accounting and customer-service purposes.",
      },
      {
        heading: "5. Your rights",
        body: `You may ask to access, correct or delete the personal data we hold about you, or withdraw consent to marketing emails at any time, by contacting ${COMPANY_EMAIL}.`,
      },
    ],
  },
  cookies: {
    title: "Cookie Policy",
    sections: [
      {
        heading: "1. What are cookies",
        body: "Cookies are small text files stored on your device that help websites function and remember your preferences.",
      },
      {
        heading: "2. Cookies we use",
        body: "Strictly necessary cookies (e.g. keeping you logged in, remembering items you've shortlisted) are always active, since the site cannot function correctly without them. With your consent, we may also use analytics cookies to understand how visitors use the site, so we can improve it.",
      },
      {
        heading: "3. Managing your choice",
        body: "You can accept or reject non-essential cookies using the banner shown on your first visit. You can change your choice at any time by clearing your browser's site data and revisiting the site.",
      },
    ],
  },
  notice: {
    title: "Legal Notice",
    sections: [
      {
        heading: "Publisher",
        body: `This website is published by ${COMPANY_NAME}, registered in The Gambia, with its registered office at ${COMPANY_ADDRESS}.`,
      },
      {
        heading: "Contact",
        body: `Email: ${COMPANY_EMAIL} — Phone: ${COMPANY_PHONE}.`,
      },
      {
        heading: "Hosting",
        body: "[Add the name and address of your hosting provider here.]",
      },
    ],
  },
};

export default legalPages;
